import React,{useState} from 'react'

// console.log(useState('Enter The Text Here2'))
export default function TextForm(props) {

    const handleUPclick=()=>{
        // console.log("UpperCase was clicked" + text);
        let newText=text.toUpperCase();
        setText(newText);
        props.showAlert("  Converted to upper case","success");
        // setText("You Have Clicked on HandleUPclick")
    }
    const handleLOWclick=()=>{
        // console.log("UpperCase was clicked" + text);
        let newText=text.toLowerCase();
        setText(newText);
        props.showAlert("  Converted to lower case","success");
        // setText("You Have Clicked on HandleUPclick")
    }
    const handleClearText=()=>{
        // console.log("UpperCase was clicked" + text);
        let newText='';
        setText(newText);
        props.showAlert("  Text deleted","success");
        // setText("You Have Clicked on HandleUPclick")
    }

    const handleCopy=()=>{
      var text=document.getElementById("myBox");
      text.select();
      navigator.clipboard.writeText(text.value);
      props.showAlert("  Text Copied","success");
    }

    const speak=()=>{
      let msg= new SpeechSynthesisUtterance();
      msg.text=text;
      window.speechSynthesis.speak(msg);
    }
    const handleOnChange=(event)=>{
        // console.log("On changed");
        setText(event.target.value);

    }
    
    const handleSpaces=()=>{
      let newText=text.split(/[ ]+/);
      setText(newText.join(" "));
      props.showAlert("  Removed extra spaces","success");
    }

    const [text,setText]= useState('');
    
  return (
    <>
    <div className="container" style={{color: props.mode==='dark'?'white':'black'}}>
      <h3 className='mb-5'>Try TextMate- Word Counter, Character Counter, Uppercase To Lowercase, Lowercase To Uppercase, Remove Extra Spaces, Listen Your Text</h3>
        <h4>{props.heading}</h4>

        <div className="mb-3">
        {/* <label for="myBox" className="form-label">Example textarea</label> */}
        <textarea className="form-control" value={text} onChange={handleOnChange} style={{backgroundColor: props.mode==='dark'?'lightgrey':'white'}} id="myBox" rows="8"></textarea>
        </div>
        <button disabled={text.length===0} className="btn-btn-primary mx-2 my-2" onClick={handleUPclick}>Convert to Uppercase</button>
        <button disabled={text.length===0} className="btn-btn-primary mx-2 my-2" onClick={handleLOWclick}>Convert to Lowercase</button>
        <button disabled={text.length===0} className="btn-btn-primary mx-2 my-2" onClick={handleClearText}>Clear Text</button>
        <button disabled={text.length===0} className="btn-btn-primary mx-2 my-2" onClick={handleCopy}>Copy Text</button>
        <button disabled={text.length===0} className="btn-btn-primary mx-2 my-2" onClick={handleSpaces}>Remove Extra Spaces</button>
        <button disabled={text.length===0} type="submit" className="btn-btn-primary mx-2 my-2" onClick={speak}>Listen</button>

    </div>
    <div className="container my-3" style={{color: props.mode==='dark'?'white':'black'}}>
      <h2>Your text summary</h2>  
      <p>Number of characters: {text.length}</p>
      <p>Number of words: {text.split(/\s+/).filter((element)=>{return element.length!==0}).length}</p>
      <p>Minutes needed to read this text :{0.008*text.split(" ").filter((element)=>{return element.length!==0}).length}</p>
      <h2>Preview</h2>
      <p>{text.length>0? text: "Enter something in the textbox above to preview it here"}</p>
    </div>
    </>
  )
}
